import { render, staticRenderFns } from "./eg_card.vue?vue&type=template&id=d4c53502&scoped=true&"
import script from "./eg_card.vue?vue&type=script&lang=js&"
export * from "./eg_card.vue?vue&type=script&lang=js&"
import style0 from "./eg_card.vue?vue&type=style&index=0&id=d4c53502&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c53502",
  null
  
)

export default component.exports